module.exports = __webpack_public_path__ + "static/media/favicon.83fc2fea.ico";